import { createApp } from "vue";
import "vuetify/styles";
import App from "./App.vue";
import { loadFonts } from "./plugins/webfontloader";
import router from "./router";

import { createVuetify } from "vuetify";

import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

import "@mdi/font/css/materialdesignicons.css";

loadFonts();

const app = createApp(App).use(router);

const vuetify = createVuetify({
  components,
  directives,
  // We can create different themes to quickly change the app's color palette from a central location
  theme: {
    defaultTheme: "light",
    // Easy way to add color variants. Provides 2 variants for each, where higher number == greater "intensity"
    variations: {
      colors: ["primary", "secondary"],
      lighten: 8,
      darken: 2,
    },
    themes: {
      light: {
        dark: false,
        colors: {
          primary: "#062D66",
          secondary: "#F47C04",
          background: "#FFFFFF",
        },
      },
    },
  },
});

app.use(vuetify);

app.mount("#app");
